import React, { memo, useState } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { GenericDivider } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Insolvent from './components/Insolvent';
import CourtJudgement from './components/CourtJudgement';
import Disqualified from './components/Disqualified';
import Registration from './components/Registration';
import Submit from '../../components/Submit';
import BusinessType from '../businessTypeSection/components/BusinessType';
import AccountType from './components/AccountType';
import DebitCard from './components/DebitCard';
import PaymentService from './components/PaymentService';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const getHeader = (errorMsg, hyperlinktext, hyperlink) => (
  <span>
    {errorMsg}
    <a href={hyperlink} target="_blank" rel="noopener noreferrer">
      {hyperlinktext}
    </a>
    .
  </span>
);

const InitialQuestionsPage = memo(function InitialQuestionsPage({
  bankId,
  onInitialFormSubmit,
  getBusinessData,
  isLinkCodeFlow,
  caseId
}) {
  const [isFormSubmitted, submitForm] = useState(false);
  return (
    <Form
      onSubmit={values => {
        if (
          !isLinkCodeFlow
            ? isSubmitDisabled(values, isLinkCodeFlow, caseId)
            : isSubmitDisabledInLinkCode(values, isLinkCodeFlow, caseId)
        ) {
          submitForm(false);
          onInitialFormSubmit(values);
        } else {
          submitForm(true);
        }
      }}
      initialValues={getBusinessData}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({
              initialQuestionsPageTitle = '',
              initialQuestionsPageSecondaryTitle = '',
              initialQuestionsIntro = '',
              initialQuestionsInsolventError = '',
              initialQuestionsCourtJudgementError = '',
              initialQuestionsDisqualifiedError = '',
              initialQuestionsRegistrationError = '',
              initialQuestionsRegistrationErrorHyperlinkText,
              initialQuestionsRegistrationErrorHyperlink,
              initialQuestionsSecondIntro,
              initialQuestionsPaymentServiceError = '',
              initialQuestionPageDebitCardError = '',
              initialQuestionSecondIntroLinkCode = '',
              initialQuestionsRegistrationErrorHyperlinkForYB
            }) => (
              <>
                <PageHeading>
                  {!isLinkCodeFlow ? initialQuestionsPageTitle : initialQuestionsPageSecondaryTitle}
                </PageHeading>
                <StandardBody>
                  {!isLinkCodeFlow && <p> {initialQuestionsIntro} </p>}
                  <p>
                    {!isLinkCodeFlow
                      ? initialQuestionsSecondIntro
                      : initialQuestionSecondIntroLinkCode}{' '}
                  </p>
                </StandardBody>
                {renderAccountType(values, isLinkCodeFlow, caseId)}
                {isLinkCodeFlow && isFormSubmitted && !values.accountType && (
                  <StandoutTile.Important>
                    {initialQuestionsPaymentServiceError}
                  </StandoutTile.Important>
                )}
                {renderDebitCard(
                  values,
                  initialQuestionPageDebitCardError,
                  isLinkCodeFlow,
                  isFormSubmitted
                )}

                {values.paymentService === 'Yes' && (
                  <StandoutTile.Important>
                    {initialQuestionsPaymentServiceError}
                  </StandoutTile.Important>
                )}
                {renderBusinessType(values, isLinkCodeFlow)}
                <GenericDivider />
                <Insolvent values={values} />
                {((isFormSubmitted && !values.insolvent) || values.insolvent === 'Yes') && (
                  <StandoutTile.Important>{initialQuestionsInsolventError}</StandoutTile.Important>
                )}
                <CourtJudgement values={values} />
                {((isFormSubmitted && !values.courtJudgement) ||
                  values.courtJudgement === 'Yes') && (
                  <StandoutTile.Important>
                    {initialQuestionsCourtJudgementError}
                  </StandoutTile.Important>
                )}
                <Disqualified isLinkCodeFlow={isLinkCodeFlow} values={values} />
                {((isFormSubmitted && !values.disqualified) || values.disqualified === 'Yes') && (
                  <StandoutTile.Important>
                    {initialQuestionsDisqualifiedError}
                  </StandoutTile.Important>
                )}
                {!isLinkCodeFlow && <Registration values={values} />}
                {!isLinkCodeFlow &&
                  ((isFormSubmitted && !values.registration) || values.registration === 'Yes') && (
                    <StandoutTile.Important>
                      {getHeader(
                        initialQuestionsRegistrationError,
                        initialQuestionsRegistrationErrorHyperlinkText,
                        bankId && bankId.toUpperCase() === 'CB'
                          ? initialQuestionsRegistrationErrorHyperlink
                          : initialQuestionsRegistrationErrorHyperlinkForYB
                      )}
                    </StandoutTile.Important>
                  )}
                {!isLinkCodeFlow && <PaymentService values={values} />}
                {!isLinkCodeFlow &&
                  ((isFormSubmitted && !values.paymentService) ||
                    values.paymentService === 'Yes') && (
                    <StandoutTile.Important>
                      {initialQuestionsPaymentServiceError}
                    </StandoutTile.Important>
                  )}

                <Submit />
              </>
            )}
          </Content>
        </form>
      )}
    />
  );
});

InitialQuestionsPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};
const renderAccountType = (values, isLinkCodeFlow, caseId) =>
  isLinkCodeFlow && !caseId && <AccountType values={values} />;
const renderDebitCard = (
  values,
  initialQuestionsPaymentServiceError,
  isLinkCodeFlow,
  isFormSubmitted
) =>
  values.accountType === 'Yes' &&
  isLinkCodeFlow && (
    <div>
      <DebitCard values={values} />
      {((isFormSubmitted && !values.debitCard) || values.debitCard === 'No') && (
        <StandoutTile.Important>{initialQuestionsPaymentServiceError}</StandoutTile.Important>
      )}
    </div>
  );
const renderBusinessType = (values, isLinkCodeFlow) => {
  if (!isLinkCodeFlow) {
    return <BusinessType values={values} />;
  } else if (isLinkCodeFlow) {
    values.businessTypeField = ' ';
  }
  return '';
};
const isSubmitDisabled = (values, isLinkCodeFlow, caseId) =>
  values.insolvent === 'No' &&
  values.courtJudgement === 'No' &&
  values.disqualified === 'No' &&
  values.registration === 'No' &&
  checkForDebitCard(values, isLinkCodeFlow, caseId) &&
  checkAccountType(values, caseId) &&
  values.paymentService === 'No';

const checkForDebitCard = (values, isLinkCodeFlow, caseId) =>
  isLinkCodeFlow && !caseId
    ? values.accountType === 'Yes'
      ? values.debitCard === 'Yes'
      : values.accountType === 'No'
    : true;

const checkAccountType = (values, caseId) =>
  caseId || values.businessTypeField || values.accountType;
const isSubmitDisabledInLinkCode = (values, isLinkCodeFlow, caseId) =>
  values.insolvent === 'No' &&
  values.courtJudgement === 'No' &&
  values.disqualified === 'No' &&
  checkForDebitCard(values, isLinkCodeFlow, caseId) &&
  checkAccountType(values, caseId);

export default InitialQuestionsPage;
